

// import './UserList.css';
import React, { useState, useEffect } from 'react';
import { Avatar, Box, Button, Grid2, MenuItem, Modal, TextField, Typography } from '@mui/material';
import Header from '../Header/Header';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import consts from "../../constant";
import Axios from "axios";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { ToastContainer, toast } from "react-toastify";
import usercalls from "../../Axios";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { Fade } from "@mui/material";



const drawerWidth = 260;




const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const StakingList = () => {

    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('lg'));

    const back = useNavigate();
    // const detail = useLocation();

    const [reason, setreason] = useState();
    const path = usercalls()

    const Navigate = useNavigate();

    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPages] = useState(0)
    const [detail, setDetail] = useState([]);

    console.log(detail, 'details');




    const [getUserList, setGetUserList] = useState([]);

    console.log(getUserList, 'getUserList');


    const getAlUser = async () => {
        try {
            const url = `${consts.BackendUrl}/admin/getAllStakingUser`;

            const response = await path.postCall({ url });
            const result = await response.json();
            console.log(result, 'result');
            if (result?.success) {
                setGetUserList(result?.result)
                setTotalPages(Math.ceil(result?.result.length / limit));
            }
        } catch (error) {
            console.log("🚀 ~ getAlUser ~ error", error)
        }
    }


    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getAlUser();
        } else {
            Navigate(`/${consts.route + '/login'}`);
        }
    }, [limit, page]);



    const formatDate = (dateString) => {
        if (!dateString) return "N/A"; // Handle null or undefined dates
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
        });
    };


    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);

    const [formData, setFormData] = useState({
        // month: '',
        percentage: 0,
        type: '',
        duration: 0,
        amount: 0
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        console.log(formData);

        let payload = {
            // month: formData.month,
            percentage: parseInt(formData.percentage),
            type: formData.type,
            duration: parseInt(formData.duration),
            amount: parseInt(formData.amount)
        }
        console.log("555", payload)

        try {
            const url = `${consts.BackendUrl}/admin/admin_update`;

            const response = await path.postCall({ url, payload });
            const result = await response.json();
            console.log(result, 'result');
            if (result?.success) {
                toast.success(result?.message)
                handleClose();

            } else {
                toast.error(result?.message)
            }
        } catch (error) {
            console.log("🚀 ~ getAlUser ~ error", error)
        }
    };

    const navigate = useNavigate()


    const handleUpdate = async () => {
        try {
            const url = `${consts.BackendUrl}/admin/cron_update`;

            const updateAdmin = await path.postCall({ url });
            const result = await updateAdmin.json();
            console.log(result, 'result');
            if (result?.success) {
                toast.success(result?.message)
                getAlUser()
                handleClose1();
            } else {
                toast.error(result?.message)
            }
        } catch (error) {
            console.log("🚀 ~ handleUpdate ~ error:", error)
        }

    }


    return (
        <div className="UserList">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
                >

                    <Grid2 container spacing={2}>
                        {/* <div style={{ backgroundColor: "lightblue", display: "flex" }} className=''>
                            <Button style={{ color: "black" }} onClick={handleOpen}>Admin Action</Button>
                        </div> */}

                        {/* 
                        <div style={{ backgroundColor: "lightblue", display: "flex" }} className=''>
                            <Button style={{ color: "black" }} onClick={() => navigate(`/${consts.route}/stakingAction`)}>Admin Action History</Button>
                        </div> */}

                        {/* 
                        <div style={{ backgroundColor: "lightblue", display: "flex" }} className=''>
                            <Button style={{ color: "black" }} onClick={handleOpen1}>Add Staking</Button>
                        </div> */}

                        <Grid2 item xs={12}>
                            <div className="custom_table" style={{ overflowX: "auto", maxHeight: "600px" }}>
                                <TableContainer sx={{ maxHeight: "500px", overflow: "auto" }}>
                                    <Table aria-label="user table">
                                        <TableHead>
                                            <TableRow>
                                                {[
                                                    "S.No", "Avatar", "User", "Email", "Asset Name", "Amount",
                                                    "Duration",
                                                    "Start Date", "End Date", "Status", "Action"
                                                ].map((header) => (
                                                    <TableCell key={header} align="center" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                                                        {header}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        {
                                            getUserList.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={9} align="center">
                                                        No data available
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                        <TableBody>
                                            {getUserList
                                                .slice((page - 1) * limit, page * limit)
                                                .map((value, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">{limit * (page - 1) + index + 1}</TableCell>
                                                        <TableCell align="center">
                                                            <Avatar alt={value?.user?.name} src={value?.user?.image || "https://i.pravatar.cc/300"} />
                                                        </TableCell>
                                                        <TableCell align="center">{value?.user?.name || "User"}</TableCell>
                                                        <TableCell align="center">{value?.user?.email}</TableCell>
                                                        <TableCell align="center">{value?.wallet?.asset_name}</TableCell>
                                                        <TableCell align="center">{value?.amount}</TableCell>
                                                        <TableCell align="center">{value?.duration} Month</TableCell>
                                                        <TableCell align="center">{formatDate(value?.startDate)}</TableCell>
                                                        <TableCell align="center">{formatDate(value?.endDate)}</TableCell>
                                                        <TableCell align="center">
                                                            {value?.locked ? (
                                                                <CheckCircleOutlineOutlinedIcon sx={{ fill: "green" }} />
                                                            ) : (
                                                                <BlockOutlinedIcon sx={{ fill: "red" }} />
                                                            )}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            <Button variant="contained"
                                                                onClick={() => navigate(`/${consts.route}/stakingDetail`, { state: value })}
                                                            >
                                                                View
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination
                                    className='pagination'
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => setPage(value)}
                                    variant="outlined"
                                    shape="rounded"
                                    sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                                />
                            </div>
                        </Grid2>
                    </Grid2>


                    <Modal open={open} onClose={handleClose}>
                        <Box sx={modalStyle}>
                            <IconButton
                                sx={{ position: 'absolute', top: 10, right: 10, backgroundColor: "lightblue" }}
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Typography variant="h6" sx={{ textAlign: 'center' }}>Monthly Stake Update</Typography>

                            {/* <TextField
                                fullWidth
                                label="Month"
                                name="month"
                                value={formData.month}
                                onChange={handleChange}
                                sx={{ my: 2 }}
                            /> */}


                            <TextField
                                fullWidth
                                select
                                label="Type"
                                name="type"
                                value={formData.type}
                                onChange={handleChange}
                                sx={{ my: 2 }}
                            >
                                <MenuItem value="profit">Profit</MenuItem>
                                <MenuItem value="loss">Loss</MenuItem>
                                <MenuItem value="reserve_activation">Reservation Action</MenuItem>
                            </TextField>

                            <TextField
                                type="number"
                                fullWidth
                                label="amount"
                                name="amount"
                                value={formData.amount}
                                onChange={handleChange}
                                sx={{ my: 2 }}
                            />

                            <TextField
                                type="number"
                                fullWidth
                                label="Percentage"
                                name="percentage"
                                value={formData.percentage}
                                onChange={handleChange}
                                sx={{ my: 2 }}
                            />


                            <TextField
                                type="number"
                                fullWidth
                                label="Duration"
                                name="duration"
                                value={formData.duration}
                                onChange={handleChange}
                                sx={{ my: 2 }}
                            />

                            <Button variant="contained" onClick={handleSubmit} fullWidth>Submit</Button>
                        </Box>
                    </Modal>





                    <Modal open={open1} onClose={handleClose1} closeAfterTransition>
                        <Fade in={open1}>
                            <Box sx={modalStyle}>
                                {/* Close Button */}
                                <IconButton

                                    sx={{ position: "absolute", top: 10, right: 10, backgroundColor: "lightblue", width: 30, height: 30 }}
                                    onClick={handleClose1}
                                >
                                    <CloseIcon />
                                </IconButton>

                                {/* Confirmation Message */}
                                <Typography variant="h6" sx={{ textAlign: "center", mb: 3 }}>
                                    Are You Sure You Want to Update This Month?
                                </Typography>

                                {/* Buttons Wrapper */}
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                                    <Button variant="contained" color="primary" onClick={handleUpdate} sx={{ flex: 1 }}>
                                        Submit
                                    </Button>
                                    <Button variant="outlined" color="secondary" onClick={handleClose1} sx={{ flex: 1 }}>
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        </Fade>
                    </Modal>




                </Box>

            </Box>
        </div>
    );
};

export default StakingList;
